/*!
 * Copyright 2024, Selerix Systems, Inc. All Rights Reserved
 * This is unpublished proprietary source code of Selerix, Inc. The
 * copyright notice above does not evidence any actual or intended
 * publication of such source code.
 */

function addModalBackdropStyle(zIndexBase) {
    var style = document.createElement('style');
    style.type = 'text/css';
    style.media = 'screen';
    style.innerHTML = 'div.modal-backdrop { z-index: ' + zIndexBase + '; }';
    document.head.appendChild(style);
}

var HistoryViewer = function (settings) {
    this.kind = settings.kind || 'Script';
    this.objectUId = settings.objectUId;
    this.type = settings.type;
    this.readonly = settings.readonly;
    this.webApiUrl = settings.webApiUrl;
    this.token = settings.token;
    this.zIndexBase = 20100;

    return this;
};

/**
 * Gets the z-index of the element or its parent's z-index.
 * @param {any} $element The jQuery element to check for z-index.
 * @returns {number} The z-index of the element or 0 if not found.
 */
HistoryViewer.prototype.getZIndex = function ($element) {
    var zIndex = 0;
    var currentElement = $element;
    var el;

    if ($element.length) {
        do {
            el = currentElement[0];
            zIndex = el ? el.computedStyleMap().get('z-index').value : 0;
            currentElement = currentElement.parent();
        } while (zIndex === 'auto' && currentElement[0] !== document);
    }

    return !isNaN(zIndex) ? zIndex : 0;
}

HistoryViewer.prototype.showHistory = function (el) {
    var that = this;
    require(['domReady!', 'vue'], function (domReady, Vue) {

        addModalBackdropStyle(that.zIndexBase);

        var historyModal = document.createElement('div');
        historyModal.id = 'historyModal';
        historyModal.classList.add('modal');
        historyModal.classList.add('fade');
        historyModal.tabIndex = '-1';
        historyModal.setAttribute(':data-backdrop', 'backdrop');
        historyModal.setAttribute('role', 'dialog');
        historyModal.setAttribute('aria-labelledby', 'historyModalTitle');
        historyModal.style.zIndex = that.zIndexBase + 1;

        var modalDialog = document.createElement('div');
        modalDialog.classList.add('modal-dialog');

        var modalContent = document.createElement('div');
        modalContent.classList.add('modal-content');

        var modalHeader = document.createElement('div');
        modalHeader.classList.add('modal-header');

        var closeButton = document.createElement('button');
        closeButton.type = 'button';
        closeButton.classList.add('close');
        closeButton.setAttribute('aria-hidden', 'true');
        closeButton.innerHTML = '&times;';
        closeButton.setAttribute('v-on:click', 'closeHistoryModal');

        var modalTitle = document.createElement('h4');
        modalTitle.classList.add('modal-title');
        modalTitle.id = 'historyModalTitle';
        modalTitle.textContent = that.kind + ' History';

        modalHeader.appendChild(closeButton);
        modalHeader.appendChild(modalTitle);

        var modalBody = document.createElement('div');
        modalBody.classList.add('modal-body');

        var noDataDiv = document.createElement('div');
        noDataDiv.setAttribute('v-if', '!hasData');
        noDataDiv.textContent = '{{ noDataText }}';

        var dataTable = document.createElement('table');
        dataTable.id = 'historyDataTable';
        dataTable.classList.add('gridvue');
        dataTable.setAttribute('v-if', 'hasData');
        dataTable.setAttribute('data-initialize', 'false');
        dataTable.setAttribute('data-responsive', 'false');
        dataTable.setAttribute('data-rowsperpage', '10');
        dataTable.style.marginTop = '0';

        var thead = document.createElement('thead');
        var headerRow = document.createElement('tr');
        var headers = ['#', 'Date/Time', 'User', ''];
        for (var i = 0; i < headers.length; i++) {
            var th = document.createElement('th');
            th.textContent = headers[i];
            headerRow.appendChild(th);
        }
        thead.appendChild(headerRow);
        dataTable.appendChild(thead);

        var tbody = document.createElement('tbody');
        tbody.setAttribute('v-for', 'record in records');
        tbody.setAttribute(':key', 'record.number');

        var rowTemplate = document.createElement('tr');

        var cellNumber = document.createElement('td');
        cellNumber.textContent = '{{ record.number }}';
        rowTemplate.appendChild(cellNumber);

        var cellDate = document.createElement('td');
        cellDate.textContent = '{{ record.date }}';
        rowTemplate.appendChild(cellDate);

        var cellUser = document.createElement('td');
        cellUser.textContent = '{{ record.userName }}';
        rowTemplate.appendChild(cellUser);

        var cellControls = document.createElement('td');
        cellControls.classList.add('controls');
        cellControls.setAttribute('align', 'center');

        var viewLink = document.createElement('a');
        viewLink.classList.add('glyphicons');
        viewLink.classList.add('glyphicons-book-open');
        viewLink.href = 'javascript:void(0);';
        viewLink.setAttribute('v-on:click', 'viewHistory(record)');
        viewLink.setAttribute('title', 'View');
        cellControls.appendChild(viewLink);

        var restoreLink = document.createElement('a');
        restoreLink.classList.add('glyphicons');
        restoreLink.classList.add('glyphicons-history');
        restoreLink.href = 'javascript:void(0);';
        restoreLink.setAttribute('v-if', '!readonly');
        restoreLink.setAttribute('v-on:click', 'restoreHistory(record)');
        restoreLink.setAttribute('title', 'Restore');
        cellControls.appendChild(restoreLink);

        rowTemplate.appendChild(cellControls);
        tbody.appendChild(rowTemplate);

        dataTable.appendChild(tbody);

        modalBody.appendChild(noDataDiv);
        modalBody.appendChild(dataTable);

        var modalFooter = document.createElement('div');
        modalFooter.classList.add('modal-footer');

        var closeButtonFooter = document.createElement('button');
        closeButtonFooter.type = 'button';
        closeButtonFooter.classList.add('btn');
        closeButtonFooter.classList.add('btn-default');
        closeButtonFooter.classList.add('btn-main');
        closeButtonFooter.textContent = 'Close';
        closeButtonFooter.setAttribute('v-on:click', 'closeHistoryModal');
        modalFooter.appendChild(closeButtonFooter);

        modalContent.appendChild(modalHeader);
        modalContent.appendChild(modalBody);
        modalContent.appendChild(modalFooter);

        modalDialog.appendChild(modalContent);

        historyModal.appendChild(modalDialog);

        document.body.appendChild(historyModal);

        var historyModalId = '#historyModal';
        var vm = new Vue({
            /** The string value of the ID of the element to bind to. */
            el: historyModalId,
            /** The internal data properties. */
            data: {
                /** History kind. */
                kind: that.kind,
                /** History type. */
                type: that.type,
                /** Has backdrop. */
                backdrop: 'false',
                /** Is read only. */
                readonly: that.readonly,
                /** Has data. */
                hasData: false,
                /** Text when no data. */
                noDataText: 'Loading...',
                /** Total records. */
                records: []
            },
            /** All methods for this component. */
            methods: {
                /**
                 * View history.
                 * @param record The history record.
                 */
                viewHistory: function (record) {
                    that.viewHistory(record);
                },
                /**
                 * Restore history.
                 * @param record The history record to restore.
                 */
                restoreHistory: function (record) {
                    that.restoreHistory(record);
                },
                /**
                 * Close history modal.
                 */
                closeHistoryModal: function () {
                    $(historyModalId).modal('hide');
                }
            }
        });

        $(historyModalId).on('show.bs.modal', function () {
            if (that.kind === 'Script') {
                HideSilverlightApps();
            }

            if (that.kind === 'TextBank') {
                hideSourceEditor(true);
            }

            var url = that.webApiUrl + '/' + that.objectUId + '?type=' + that.type;
            if (that.token && that.token.length > 0) {
                url += '&token=' + that.token;
            }

            $.ajax({
                type: 'GET',
                url: url,
                dataType: 'json',
                crossDomain: true
            }).done(function (data) {
                if (data && data.length > 0) {
                    vm.hasData = true;
                    vm.records = data.reverse();
                } else {
                    vm.hasData = false;
                    vm.noDataText = 'No records found.';
                }
            }).fail(function () {
                vm.noDataText = "Error loading data - QX Admin service isn't available.";
            });
        });

        $(historyModalId).on('hidden.bs.modal', function () {
            that.restoreHideModal(that, $(historyModalId));

            if (that.kind === 'Script') {
                RestoreSilverlightApps();
            }

            if (that.kind === 'TextBank') {
                drawSourceEditor(true);
            }

            if (that.zIndexParent) {
                $('.modal-backdrop').css('z-index', that.zIndexParent);
            }

            $(historyModalId).remove();
        });        

        var bdParent = $('.modal-backdrop');
        if (bdParent && bdParent.length > 0) {
            that.zIndexParent = that.getZIndex(bdParent);
            vm.backdrop = 'false';

            // TODO: Remove this check when Text Bank Editor would be 
            // a normal Bootstrap dialog and not a something weird like now.
            if (that.kind === "Script") {
                that.patchHideModal(that, $(historyModalId));
            }
        }

        $(historyModalId).modal({ show: true });
    });
};

HistoryViewer.prototype.viewHistory = function (record) {
    var that = this;
    require(['domReady!', 'vue'], function (domReady, Vue) {
        var viewHistoryModal = document.createElement('div');
        viewHistoryModal.id = 'viewHistoryModal';
        viewHistoryModal.classList.add('modal');
        viewHistoryModal.classList.add('fade');
        viewHistoryModal.tabIndex = '-1';
        viewHistoryModal.setAttribute('role', 'dialog');
        viewHistoryModal.setAttribute('data-backdrop', 'false');
        viewHistoryModal.style.zIndex = that.zIndexBase + 101;

        var modalDialog = document.createElement('div');
        modalDialog.classList.add('modal-dialog');

        var modalContent = document.createElement('div');
        modalContent.classList.add('modal-content');

        var modalHeader = document.createElement('div');
        modalHeader.classList.add('modal-header');

        var closeButton = document.createElement('button');
        closeButton.type = 'button';
        closeButton.classList.add('close');
        closeButton.setAttribute('aria-hidden', 'true');
        closeButton.innerHTML = '&times;';
        closeButton.setAttribute('v-on:click', 'closeViewHistoryModal');

        var modalTitle = document.createElement('h4');
        modalTitle.classList.add('modal-title');
        modalTitle.id = 'viewHistoryModalTitle';
        modalTitle.innerHTML = 'Revision <b>#{{ record.number }}</b> at {{ record.date }}';

        modalHeader.appendChild(closeButton);
        modalHeader.appendChild(modalTitle);

        var modalBody = document.createElement('div');
        modalBody.classList.add('modal-body');

        var textArea = document.createElement('textarea');
        textArea.classList.add('form-control');
        textArea.style.maxWidth = '100%';
        textArea.rows = '10';
        textArea.setAttribute('readonly', true);
        textArea.textContent = '{{ recordVal }}';

        modalBody.appendChild(textArea);

        var modalFooter = document.createElement('div');
        modalFooter.classList.add('modal-footer');

        var closeButtonFooter = document.createElement('button');
        closeButtonFooter.type = 'button';
        closeButtonFooter.classList.add('btn');
        closeButtonFooter.classList.add('btn-default');
        closeButtonFooter.classList.add('btn-main');
        closeButtonFooter.textContent = 'Close';
        closeButtonFooter.setAttribute('v-on:click', 'closeViewHistoryModal'); 
        modalFooter.appendChild(closeButtonFooter);

        var restoreButton = document.createElement('button');
        restoreButton.type = 'button';
        restoreButton.classList.add('btn');
        restoreButton.classList.add('btn-default');
        restoreButton.textContent = 'Restore';
        restoreButton.setAttribute('v-if', '!readonly');
        restoreButton.setAttribute('v-on:click', 'restoreRecord');
        modalFooter.appendChild(restoreButton);

        modalContent.appendChild(modalHeader);
        modalContent.appendChild(modalBody);
        modalContent.appendChild(modalFooter);

        modalDialog.appendChild(modalContent);

        viewHistoryModal.appendChild(modalDialog);

        document.body.appendChild(viewHistoryModal);

        var viewHistoryModalId = '#viewHistoryModal';

        var vm = new Vue({
            /** The string value of the ID of the element to bind to. */
            el: viewHistoryModalId,
            /** The internal data properties. */
            data: {
                /** The history record. */
                record: record,
                /** The history record value. */
                recordVal: 'Loading...',
                /** Is read only. */
                readonly: that.readonly
            },
            /** All methods for this component. */
            methods: {
                /**
                 * Close view history modal.
                 */
                closeViewHistoryModal: function () {
                    $(viewHistoryModalId).modal('hide');
                },
                /**
                 * Restore history record.
                 * @param record The history record to restore.
                 */
                restoreRecord: function () {
                    that.restoreHistory(record);
                    $(viewHistoryModalId).modal('hide');
                }
            }
        });

        $(viewHistoryModalId).on('shown.bs.modal', function () {
            var url = that.webApiUrl + '/revision/' + record.revision + '?type=' + that.type;
            if (that.token && that.token.length > 0) {
                url += '&token=' + that.token;
            }

            $.ajax({
                type: 'GET',
                url: url,
                dataType: 'json',
                crossDomain: true
            }).done(function (data) {
                if (data && data.length > 0) {
                    vm.recordVal = data[data.length - 1].value;
                }
            }).fail(function () {
                alert("Error loading data - QX Admin service isn't available.");
            });
        });        

        $(viewHistoryModalId).on('hidden.bs.modal', function () {
            that.restoreHideModal(that, $(viewHistoryModalId));

            $(viewHistoryModalId).remove();

            if (that.closeWithParent) {
                that.$modal.modal('hide');
            } else {
                that.focusNoScroll();
            }
        });

        $(viewHistoryModalId).modal({ show: true });
    });
};

HistoryViewer.prototype.restoreHistory = function (record) {
    var that = this;
    var url = that.webApiUrl + '/revision/' + record.revision + '?type=' + that.type;
    if (that.token && that.token.length > 0) {
        url += '&token=' + that.token;
    }

    $.ajax({
        type: 'GET',
        url: url,
        dataType: 'json',
        crossDomain: true
    }).done(function (data) {
        if (data && data.length > 0) {
            var value = data[data.length - 1].value;
            that._restoreHistoryImpl(value);
            if (that.$modal) {
                that.$modal.modal('hide');
            }
        }
    }).fail(function () {
        alert("Error loading data - QX Admin service isn't available.");
    });
};

HistoryViewer.prototype._restoreHistoryImpl = function (value) {
    var that = this;

    if (that.kind === "Script") {
        if (Silverlight_Apps && Silverlight_Apps.length > 0) {
            Silverlight_Apps[0].Content.Page.SetText(value);
            return;
        }

        var editorObj = _getJSScriptEditor($(document.body), '.monaco-script-editor');
        if (editorObj && editorObj.editor) {
            editorObj.editor.getModel().setValue(value);
            return;
        }
    }

    if (that.kind === "TextBank") {
        setTextBankEditorValue(value);
        return;
    }

    throw new Error('Cannot restore history record of the type "' + that.kind + '".');
};

HistoryViewer.prototype.focusNoScroll = function () {
    if (this.$modal && this.$modal.focus) {
        this.$modal.focus();
    }
};

HistoryViewer.prototype.restoreHideModal = function (obj, $modal) {
    if (obj && obj.hideModalOriginal) {
        $modal.modal.Constructor.prototype.hideModal = obj.hideModalOriginal;
    }
};

HistoryViewer.prototype.patchHideModal = function (obj, $modal) {
    obj.hideModalOriginal = $modal.modal.Constructor.prototype.hideModal;

    // https://github.com/twbs/bootstrap/issues/15837
    $modal.modal.Constructor.prototype.hideModal = function () {
        // don't touch backdrop & scroll
        this.$element.hide();
        this.$element.trigger('hidden.bs.modal');
    };
};